import { Yup } from "lib/extendYup";

export const hospitalConfigValidationSchema = Yup.object().shape({
  wbcRange: Yup.object().range().required("WBC normal range is required"),
  haemoglobinRangeFemale: Yup.object().range().required("Normal Haemoglobin range for Females is required"),
  haemoglobinRangeMale: Yup.object().range().required("Normal Haemoglobin range for Males is required"),
  neutrophilRange: Yup.object().range().required("Neutrophils normal range is required"),
  plateletRange: Yup.object().range().required("Platelet normal range is required"),
  neutrophilThreshold: Yup.string().required("Neutrophils threshold is required"),
});
